
import { TranslationRecord } from '../../types';

export const contact: TranslationRecord = {
  // Contact page
  contactTitle: 'Επικοινωνία',
  contactSubtitle: 'Επικοινωνήστε μαζί μας για κρατήσεις ή οποιεσδήποτε ερωτήσεις',
  contactForm: 'Φόρμα Επικοινωνίας',
  contactInformation: 'Στοιχεία Επικοινωνίας',
  
  // Contact Hero
  contactHeroTitle: 'Επικοινωνήστε Μαζί μας',
  contactHeroSubtitle: 'Είμαστε εδώ για να κάνουμε τη διαμονή σας στη Θεσσαλονίκη αξέχαστη. Επικοινωνήστε μαζί μας για κρατήσεις, ερωτήσεις ή εξατομικευμένη βοήθεια.',
  
  // Form fields
  name: 'Όνομα',
  email: 'Email',
  message: 'Μήνυμα',
  send: 'Αποστολή',
  sendMessage: 'Αποστολή Μηνύματος',
  
  // Contact information
  contactInfo: 'Στοιχεία Επικοινωνίας',
  address: 'Διεύθυνση',
  phone: 'Τηλέφωνο',
  emailAddress: 'Email',
  
  // Form labels
  firstName: 'Όνομα',
  lastName: 'Επώνυμο',
  phoneNumber: 'Τηλέφωνο',
  subject: 'Θέμα',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  guests: 'Επισκέπτες',
  
  // Form validation
  nameRequired: 'Το όνομα είναι υποχρεωτικό',
  emailRequired: 'Το email είναι υποχρεωτικό',
  emailInvalid: 'Παρακαλώ εισάγετε έγκυρο email',
  messageRequired: 'Το μήνυμα είναι υποχρεωτικό',
  
  // Success/Error messages
  messageSent: 'Το μήνυμα στάλθηκε επιτυχώς!',
  messageError: 'Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
  
  // WhatsApp
  whatsappContact: 'Επικοινωνία μέσω WhatsApp',
  whatsappMessage: 'Γεια σας! Θα θέλα να κάνω μια κράτηση στο Loena Luxury Suites.',
  whatsAppAssistance: 'Επικοινωνήστε μαζί μας στο WhatsApp',
  
  // Contact methods
  callUs: 'Καλέστε μας',
  emailUs: 'Στείλτε μας email',
  visitUs: 'Επισκεφτείτε μας',
  
  // Hours
  receptionHours: 'Ώρες Λειτουργίας',
  responseTime: 'Χρόνος Απάντησης',
  within24Hours: 'Εντός 24 ωρών',
  businessHours: 'Ώρες Λειτουργίας',
  availableDaily: 'Διαθέσιμοι Καθημερινά 9:00 - 21:00',
  afterHoursCheckIn: '(διαδικτυακό check-in διαθέσιμο εκτός ωραρίου)',
  weekdayHours: 'Δευτέρα έως Παρασκευή: 8:00 π.μ. - 3:00 μ.μ.',
  weekendHours: 'Σαββατοκύριακα & Αργίες: 11:00 π.μ. - 3:00 μ.μ.',
  
  // Additional fields
  location: 'Τοποθεσία',
  directBookingBenefits: 'Επιπλέον Πλεονεκτήματα Άμεσης Κράτησης',
  discountBenefit: '10% Έκπτωση Άμεσης Κράτησης',
  earlyCheckinBenefit: 'Check-in πριν τις 3:00 μ.μ. (κατόπιν διαθεσιμότητας)',
  lateCheckoutBenefit: 'Check-out μετά τις 11:00 π.μ. (κατόπιν διαθεσιμότητας)',
  personalizedRecommendations: 'Εξατομικευμένες τοπικές προτάσεις',
};
